import BaseNumberField from '@rjsf/core/lib/components/fields/NumberField'
import {
  FieldProps,
} from '@rjsf/utils';
import { useEffect } from 'react';


export default function NumberField(props: FieldProps) {

  const {onChange, value, formData} = props;
  useEffect(() => {
    if (props.schema.const&& (props.schema.const !== value || props.schema.const !== formData)) {
        
      // This needs to be send to the next frame for some reason, or else it won't update
      setTimeout(()=>onChange(props.schema.const), 0);
      
    }
  }, [props, onChange, value, formData])

  return (<BaseNumberField {...props} 
      onWheel={(event) => (event.target as HTMLInputElement).blur()}/>)
}
